import { render } from "./MyFooter.vue?vue&type=template&id=699b1dea&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"

import "./MyFooter.vue?vue&type=style&index=0&id=699b1dea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699b1dea"]])

export default __exports__